export default __webpack_public_path__ + "static/media/information--limited-access-road--g1.10cc71f3.png";